import BASEURLGESTTOR from '../api/gesttor'
import { atualizarAssinaturasPayload, atualizarItemAssinaturaPayload, buscarAssinaturasQuery, cadastrarAssinaturasPayload, cadastrarItem } from "../../interfaces/assinaturas";

export function listarAssinaturas(queryParams: buscarAssinaturasQuery) {
    return BASEURLGESTTOR.get(`/assinatura?nomeFantasia=${queryParams.nomeFantasia}&situacao=${queryParams.situacao}&tipo=${queryParams.tipo}&cobrancaAutomatica=${queryParams.cobrancaAutomatica}&recorrencia=${queryParams.recorrencia}`);
}

export function cadastrarAssinatura(payload: cadastrarAssinaturasPayload) {
    return BASEURLGESTTOR.post(`/assinatura`, payload);
}

export function atualizarAssinatura(idAssinaturas: string, payload: atualizarAssinaturasPayload) {
    return BASEURLGESTTOR.patch(`/assinatura/${idAssinaturas}`, payload);
}

// Item das Assinaturas

export function cadastrarItemAssinatura(payload: cadastrarItem) {
    return BASEURLGESTTOR.post(`/assinatura/item`, payload);
}

export function atualizarItemAssinatura(idItem: string, payload: atualizarItemAssinaturaPayload) {
    return BASEURLGESTTOR.patch(`/assinatura/item/${idItem}`, payload);
}
